import { Table } from '@lmc/ui-kit'
import { CQITabID, TablesDataSource } from './utils'
import { TFunction, useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import { ColumnsType } from 'antd/es/table'
import { cqiConstants } from 'locale/cqi'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

type BaseTableProps = {
  tabID: CQITabID
  dataSource: TablesDataSource[]
  isLoading: boolean
}

/**
 * Modify this component only if you want to change all CQI Tables
 * if you want to modify a specific Table (ex: SafeTable, WellLedTable, please go to their specific component)
 * This is the most generic component for all CQI Tables
 */
const BaseCQITable = ({ tabID, dataSource, isLoading }: BaseTableProps) => {
  const { t } = useTranslation(NAMESPACE.CQI)
  const columns = getColumns<TablesDataSource>(t, tabID)

  return (
    <Table<TablesDataSource>
      loading={isLoading}
      columns={columns}
      dataSource={dataSource}
      pagination={false}
    />
  )
}

export const getColumns = <T extends object>(
  t: TFunction<string, undefined>,
  tabID: CQITabID
): ColumnsType<T> => [
  {
    key: 'indicator',
    title: (
      <Text weight="bold">
        {t(cqiConstants.TYPE_INDICATOR, {
          type: t(cqiConstants[tabID]).toUpperCase(),
        })}
      </Text>
    ),
    dataIndex: 'indicator' as keyof TablesDataSource,
    render: (value) => <Text>{value}</Text>,
  },
  {
    key: 'timeframe',
    title: <Text weight="bold">{t(cqiConstants.TIMEFRAME)}</Text>,
    dataIndex: 'timeframe' as keyof TablesDataSource,
    render: (value) => <Text>{value}</Text>,
  },
  {
    key: 'output',
    title: <Text weight="bold">{t(cqiConstants.OUTPUT)}</Text>,
    dataIndex: 'output' as keyof TablesDataSource,
    render: (value) => {
      let parsedValue: string = value

      if (value === undefined) {
        parsedValue = '-'
      }

      return <OutputText weight="bold">{parsedValue}</OutputText>
    },
  },
]

const OutputText = styled(Text)`
  color: ${({ theme }) => theme.color.status.primary};
`

export default BaseCQITable
